import React, { useCallback, useState } from "react";
import UsersView from './view';

const defaultState = {
	tabIndex: 1,
};

const Users = () => {
	const [state, setState] = useState(defaultState);

	const handleTabChange = useCallback((event, tabIndex) => {
		setState(prevState => ({
			...prevState,
			tabIndex,
		}));
  }, []);

	return (
		<UsersView
			tabIndex={state.tabIndex}
			handleTabChange={handleTabChange}
		/>
	)
};

export default Users;